//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import { InstagramAccountAudienceActions } from '@instagram-account/redux/audience/instagramAccountAudienceActions';
import {
  IInstagramAudienceState,
  INSTAGRAM_AUDIENCE_ACTIONS,
} from '@instagram-account/redux/audience/instagramAccountAudienceModel';

const initialState: IInstagramAudienceState = {
  isFetchingSummaryTopRecentEngagers: false,
  summaryTopRecentEngagers: [],
  fetchingSummaryTopRecentEngagersError: undefined,
};

export default function InstagramAccountAudienceReducer(
  state: IInstagramAudienceState = initialState,
  action: InstagramAccountAudienceActions,
): IInstagramAudienceState {
  switch (action.type) {
    case INSTAGRAM_AUDIENCE_ACTIONS.REQUEST_SUMMARY_TOP_RECENT_ENGAGERS: {
      return {
        ...state,
        isFetchingSummaryTopRecentEngagers: true,
        fetchingSummaryTopRecentEngagersError: undefined,
      };
    }
    case INSTAGRAM_AUDIENCE_ACTIONS.RECEIVE_SUMMARY_TOP_RECENT_ENGAGERS: {
      return {
        ...state,
        isFetchingSummaryTopRecentEngagers: false,
        summaryTopRecentEngagers: action.engagers,
      };
    }
    case INSTAGRAM_AUDIENCE_ACTIONS.RECEIVE_SUMMARY_TOP_RECENT_ENGAGERS_FAILURE: {
      return {
        ...state,
        isFetchingSummaryTopRecentEngagers: false,
        fetchingSummaryTopRecentEngagersError: action.error,
      };
    }
    default:
      return state;
  }
}
